export default __webpack_public_path__ + "static/media/kabbik.24bdee81.jpg";